module.exports = __webpack_public_path__ + "img/Drapes.ffa6d5ed.png";